module.exports = __webpack_public_path__ + "static/web-9-f799cb2a162dfbd061e2db0b60b79772.mp4";